module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Date From:")]), _vm._v(" "), _c('date-picker', {
    staticStyle: {
      "width": "100% !important"
    },
    attrs: {
      "lang": "en"
    },
    model: {
      value: (_vm.objDiscountReportFilters.startDate),
      callback: function($$v) {
        _vm.$set(_vm.objDiscountReportFilters, "startDate", $$v)
      },
      expression: "objDiscountReportFilters.startDate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Date To:")]), _vm._v(" "), _c('date-picker', {
    staticStyle: {
      "width": "100% !important"
    },
    attrs: {
      "lang": "en"
    },
    model: {
      value: (_vm.objDiscountReportFilters.endDate),
      callback: function($$v) {
        _vm.$set(_vm.objDiscountReportFilters, "endDate", $$v)
      },
      expression: "objDiscountReportFilters.endDate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Requestor:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.discountRequestors,
      "label": "Select Requestor",
      "item-value": "id",
      "autocomplete": "",
      "solo": ""
    },
    model: {
      value: (_vm.objDiscountReportFilters.requestor),
      callback: function($$v) {
        _vm.$set(_vm.objDiscountReportFilters, "requestor", $$v)
      },
      expression: "objDiscountReportFilters.requestor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Authoriser:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.discountAuthorisers,
      "label": "Select Authorizer",
      "item-value": "id",
      "autocomplete": "",
      "solo": ""
    },
    model: {
      value: (_vm.objDiscountReportFilters.authorizer),
      callback: function($$v) {
        _vm.$set(_vm.objDiscountReportFilters, "authorizer", $$v)
      },
      expression: "objDiscountReportFilters.authorizer"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncClearFilters()
      }
    }
  }, [_vm._v("Clear Filter")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncGenerateDiscountReport()
      }
    }
  }, [_vm._v("Generate")])], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "requiredMessage",
    staticStyle: {
      "padding-bottom": "75px"
    },
    attrs: {
      "lg12": ""
    }
  }, [_vm._v("\n\t\t\t \n\t\t")])], 1)], 1)
},staticRenderFns: []}